import ApprovedPostingTabContent from './ApprovedPostingTabContent';
import {
  setApprovedGLPostingFilters,
  resetApprovedGLPostingFiltersState,
} from '../../../../redux-slice/weeklyGLPostingFilters';

const selectApprovedGLPostingFilters = (state) => state.weeklyGLPostingFilters?.approvedGLPosting;

const ApprovedTab = () => (
  <ApprovedPostingTabContent
    filterSelector={selectApprovedGLPostingFilters}
    setFilters={setApprovedGLPostingFilters}
    resetFilters={resetApprovedGLPostingFiltersState}
  />
);

export default ApprovedTab;
